import intl from 'react-intl-universal';
import { NewGoodType } from '@/type/components';
import { Row, Col, Button } from 'antd';
import styles from './index.less';

type NewGoodProps = {
    title: string;
    good?: NewGoodType;
    editGood: () => void;
    disable: boolean;
};

const NewGood: React.FC<NewGoodProps> = ({
    title,
    good,
    editGood,
    disable,
}) => {
    return (
        <div className={styles.goodWrap}>
            <div>{title}</div>
            <div className={styles.right}>
                {good ? (
                    <div className={styles.contentWrap}>
                        <div className={styles.content}>
                            <Row>
                                <Col>{intl.get('系列名称：')}</Col>
                                <Col>{good.seriesName}</Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('商品名称：')}</Col>
                                <Col>{good.productName}</Col>
                            </Row>
                        </div>
                        <a
                            onClick={editGood}
                            style={{
                                visibility: disable ? 'hidden' : 'visible',
                            }}
                        >
                            {intl.get('编辑')}
                        </a>
                    </div>
                ) : disable ? (
                    '-'
                ) : (
                    <Button onClick={editGood}>{intl.get('添加商品')}</Button>
                )}
            </div>
        </div>
    );
};

export default NewGood;
